import generateIcon from "../generateIcon";

const AddAdmins = generateIcon("fas fa-user-edit");

export default AddAdmins;